<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:usersgetfilter_header' | i18next }}<span class="header-details">{{ filtersetName || '' }}</span>
    </span>
    <div class="right">
      <app-basic-button type="secondary" size="medium" (click)="collapseExpandAll()" style="margin-left: 16px;">
        {{ collapseExpandText }}
      </app-basic-button>
      <app-filter-input [(model)]="filter" (modelChange)="applyFilter()" [placeholder]="'users:filterLabel' | i18next"
        [width]="'332px'"></app-filter-input>
    </div>
  </div>
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <div class="resource-type-groups">
      <div class="accordion-container" *ngFor="let rt of resourceTypeContextList">
        <div class="accordion-header" (click)="toggleAccordion(rt)" [class.expanded]="rt.isExpanded">
          <h3>
            <a class="dropdown-button" [class.rotate-right]="rt.isExpanded">
              <i class="fas fa-chevron-down"></i>
            </a>
            <span>{{ getResourceTypeName(rt.resourceTypeId) }}</span>
            <span class="rightfloat rt-status-text" [class.inactive]="!getActiveStatusFlag(rt.resourceTypeId)">
              {{ getActiveStatusFlag(rt.resourceTypeId) ? ( 'users:usersgetfilter_lang_active' | i18next ) : (
              'users:usersgetfilter_lang_inactive' | i18next ) }}
            </span>
          </h3>
        </div>

        <div class="accordion-body" *ngIf="rt.isExpanded">
          <div class="resource-container">
            <div class="context-container-width">
              <div class="quality-box-wrapper">
                <div class="resource-box" *ngFor="let resource of getFilteredResources(rt.resourceTypeId)">
                  <div class="display-box-item-wrapper" [attr.item-id]="resource.resourceId">
                    <span> {{resource.description | htmlDecode}}</span>
                    <button class="delete-button far fa-times"
                      (click)="removeResource(rt.resourceTypeId, resource)"></button>
                  </div>
                </div>
                <app-basic-button *ngIf="(resourceItemsAvailable[rt.resourceTypeId] || []).length > 0" type="primary"
                  size="small" (click)="addResource(rt.resourceTypeId)" class="add-context-btn">
                  <i class="fas fa-plus fa-sm"></i>
                </app-basic-button>
              </div>
            </div>

            <div class="actions-wrapper">
              <div class="actions-on-wrapper">
                <div>{{ 'users:usersgetfilter_lang_activeon' | i18next }}</div>
                <div class="actions-on">
                  <app-basic-checkbox *ngFor="let context of rt.contextList" size="small"
                    [label]="'users:context_'+ context.contextDescription.toLowerCase() | i18next "
                    [model]="isContextChecked(rt.resourceTypeId, context.contextId)"
                    (change)="onContextCheckboxChange(rt.resourceTypeId, context.contextId, $event)">
                  </app-basic-checkbox>
                </div>
              </div>
              <div class="button-container">
                <app-basic-button type="secondary" size="small" (click)="undoChanges(rt.resourceTypeId)"
                  [disabled]="!hasChanges(rt.resourceTypeId) || isLoading">
                  {{ 'users:UndoChanges' | i18next }}
                </app-basic-button>
                <app-basic-button type="primary" size="small" (click)="saveChanges(rt.resourceTypeId)"
                  [disabled]="!hasChanges(rt.resourceTypeId) || isLoading">
                  {{ 'users:Save' | i18next }}
                </app-basic-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
